module.exports = __webpack_public_path__ + "img/company_banner.82361094.svg";